









































































































































import { defineComponent, reactive, toRefs, onMounted, watch, onBeforeUnmount, ref, PropType } from '@vue/composition-api'
import * as Common from "../commons/common"
import http from "../plugins/http"
import AlertArea from "./AlertArea.vue"
import { SearchCondition, CramStudent, Curriculum } from "../modules/teacher/CramStudentList"
import { BTable } from 'bootstrap-vue'

export interface Data {
  condition: SearchCondition
  cramStudents: CramStudent[]
  curriculums: Curriculum[]
  currentPage: number
  perPage: number
  fields: any[]
  isAllCheckedDelete: boolean
  delete_student_ids: number[]
  errors: string[]
  items: CramStudent[]
  isShowPagination: boolean
  totalCount: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  props: {
    isDispDownloadButton: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    isDispDetailButton: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    isDispDeleteButton: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    perPage: {
      type: Number as PropType<number>,
      default: 100
    }
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      cramStudents: new Array<CramStudent>(),
      curriculums: [],
      currentPage: 1,
      perPage: 100,
      fields: [],
      isAllCheckedDelete: false,
      delete_student_ids: [],
      errors: [],
      items: [],
      isShowPagination: false,
      totalCount: 0,
    });

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.delete_student_ids = [];
      state.isAllCheckedDelete = false;
      await http.get(`/api/cram_student_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.cramStudents = response.data.cram_students;
        state.curriculums = response.data.curriculums;
        state.currentPage = 1;
        state.totalCount = state.cramStudents.length == 0 ? 0 : state.cramStudents[0].full_count;

        state.fields = [];

        state.fields.push({key: 'student_code', label: '生徒CD', sortable: true, class: 'text-center b-table-th-td'});
        state.fields.push({key: 'cram_code', label: '塾生CD', sortable: true, class: 'text-center b-table-th-td'});
        state.fields.push({key: 'name', label: '氏名', sortable: true, class: 'text-center b-table-th-td'});
        state.fields.push({key: 'nendo', label: '年度', sortable: true, class: 'text-center b-table-th-td'});
        state.fields.push({key: 'grade', label: '学年CD', sortable: true, class: 'text-center b-table-th-td'});
        
        if(props.isDispDeleteButton){
          state.fields.push({key: 'delete', label: '削除', class: 'text-center'});
        }

        if(props.isDispDetailButton){
          state.fields.push({key: "result", label: "成績", class: 'text-center b-table-th-td'});
        }

        state.curriculums.forEach(curriculum => {
          state.fields.push({key: `course_code_${curriculum.id}`, label: '講座CD', sortable: true, class: 'text-center b-table-th-td'});
          state.fields.push({key: `course_name_${curriculum.id}`, label: '講座名', sortable: true, class: 'text-center b-table-th-td'},);
          state.fields.push({key: `course_type_${curriculum.id}`, label: '講座種別', sortable: true, class: 'text-center b-table-th-td'},);
          state.fields.push({key: `room_code_${curriculum.id}`, label: '教室CD', sortable: true, class: 'text-center b-table-th-td'},);
          state.fields.push({key: `room_name_${curriculum.id}`, label: '教室名', sortable: true, class: 'text-center b-table-th-td'},);
          state.fields.push({key: `class_code_${curriculum.id}`, label: 'クラスCD', sortable: true, class: 'text-center b-table-th-td'},);
          state.fields.push({key: `class_name_${curriculum.id}`, label: 'クラス名', sortable: true, class: 'text-center b-table-th-td'},);
          state.fields.push({key: `level_${curriculum.id}`, label: 'VSH', sortable: true, class: 'text-center b-table-th-td'},);
        })

        context.root.$store.commit("setStudentListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * ページング
     ******************************/

    const changePage = async (page: number) => {
      state.condition.page = page;
      await search();
    };

    /**
     * 生徒削除処理
     */
    const studentDelete = async (): Promise<void> => {

      if (!state.delete_student_ids.length) {
        alert(`削除する生徒をチェックしてください。`);
        return;
      }

      if (!confirm(`本当に削除してよろしいでしょうか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/cram_student_list/delete_students`, {student_ids: state.delete_student_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    }

    /**
     * 生徒マスタに紐づくUser登録
     */
    const insertUser = async (): Promise<void> => {

      if (!confirm(`User登録を行います。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/cram_student_list/insert_user`).then(response => {
        alert(`処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      if(!state.cramStudents || state.cramStudents.length == 0){
        alert("出力対象がありません。");
        return;
      }

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");

      await http.get(`/api/cram_student_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `生徒マスタ.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
      state.condition.event_code = context.root.$store.state.events[0].event_code;
    };

    /******************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ******************************/

    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");

      if(tableArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop - 50) + "px";
      }
    };

    /******************************
     * 試験結果一覧画面へ
     ******************************/

    const toStudentSheetList = (cram_student: CramStudent) => {
      context.root.$store.commit("setCramStudent", cram_student);
      context.root.$store.commit("setCramStudentId", cram_student.id);
      context.root.$router.push(`/teacher_site/student_sheet_list`).catch(err => {});
    };

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {

      state.delete_student_ids = [];

      if (newVal) {
        state.delete_student_ids = state.cramStudents.map(x => x.id);
      }
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      document.body.style.overflow = "hidden";
      state.condition = context.root.$store.state.studentListCondition;
      if(!state.condition.event_code){
        state.condition.event_code = context.root.$store.state.events[0].event_code;
      }
      state.perPage = props.perPage;
      await search();
      state.isShowPagination = true;
      adjustHeight();
      window.addEventListener("resize", adjustHeight);
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      document.body.style.overflow = "";
    });

    return {
      ...toRefs(state),
      search,
      clearCondition,
      studentDelete,
      insertUser,
      download,
      adjustHeight,
      changePage,
      toStudentSheetList,
    };
  }
})
